import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "row"
    },
    contentContainer: {
        flex: 1,
        alignContent: "flex-start",
        alignItems: "flex-start"
    },
    companyLogo: {
        width: 70,
        height: 70
    }
});
export default stylesheet;
